export default __webpack_public_path__ + "static/media/streak 77 badge.47e1ef80.svg";